"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _propTypes2 = require("../helpers/prop-types");
var _colors = require("../helpers/colors");
var _reactVis = require("react-vis");
var _empty = require("./empty");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultColorScale = (0, _colors.colorScaleCategorical)();
var DonutChart = /*#__PURE__*/function (_Component) {
  _inherits(DonutChart, _Component);
  var _super = _createSuper(DonutChart);
  function DonutChart() {
    var _this;
    _classCallCheck(this, DonutChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hoveredValue: undefined
    });
    _defineProperty(_assertThisInitialized(_this), "_renderCenterText", function () {
      var hoveredValue = _this.state.hoveredValue;
      var _this$props = _this.props,
        data = _this$props.data,
        arcValueFormat = _this$props.arcValueFormat;
      var total = data.map(function (e) {
        return e.v;
      }).reduce(function (a, b) {
        return a + b;
      });
      return hoveredValue !== undefined ? /*#__PURE__*/_react.default.createElement(_reactVis.LabelSeries, {
        data: [{
          x: 0,
          y: 4,
          label: "".concat((hoveredValue.pct * 100).toFixed(1), "%"),
          style: {
            textAnchor: "middle"
          }
        }, {
          x: 0,
          y: 2.5,
          label: "".concat(arcValueFormat ? arcValueFormat(hoveredValue.cnt) : hoveredValue.cnt),
          style: {
            textAnchor: "middle",
            fontSize: "2.5em",
            fontWeight: 500
          }
        }, {
          x: 0,
          y: -3,
          label: "".concat(hoveredValue.key),
          style: {
            textAnchor: "middle",
            fill: hoveredValue.color
          }
        }]
      }) : /*#__PURE__*/_react.default.createElement(_reactVis.LabelSeries, {
        data: [{
          x: 0,
          y: 2.5,
          label: "".concat(arcValueFormat ? arcValueFormat(total) : total),
          style: {
            textAnchor: "middle",
            fontSize: "2.5em",
            fontWeight: 500
          }
        }, {
          x: 0,
          y: -3,
          label: "Total",
          style: {
            textAnchor: "middle"
          }
        }]
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_processData", function () {
      var _this$props2 = _this.props,
        data = _this$props2.data,
        colorMap = _this$props2.colorMap;
      var hoveredValue = _this.state.hoveredValue;
      var total = data.map(function (e) {
        return e.v;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      var angle0 = 0;
      return data.map(function (_ref) {
        var k = _ref.k,
          v = _ref.v;
        var radius = hoveredValue && hoveredValue.key === k ? 11 : 10;
        var opacity = hoveredValue && hoveredValue.key !== k ? 0.2 : 1;
        var pct = v / total;
        var angle = angle0 + Math.PI * 2 * pct;
        var arc = {
          angle0: angle0,
          angle: angle,
          radius0: 7,
          radius: radius,
          opacity: opacity,
          color: colorMap ? colorMap[k] : defaultColorScale(k),
          key: k,
          cnt: v,
          // store count for later use in tooltip
          pct: pct // calculate percentage for later use in tooltip
        };

        angle0 = angle;
        return arc;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_updateHovered", function (val) {
      _this.setState({
        hoveredValue: val
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_clearHovered", function () {
      _this.setState({
        hoveredValue: undefined
      });
    });
    return _this;
  }
  _createClass(DonutChart, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        width = _this$props3.width,
        height = _this$props3.height,
        margin = _this$props3.margin,
        onValueClick = _this$props3.onValueClick;
      return /*#__PURE__*/_react.default.createElement(_reactVis.XYPlot, {
        width: width,
        height: height,
        margin: margin,
        xDomain: [-10, 10],
        yDomain: [-10, 10]
      }, /*#__PURE__*/_react.default.createElement(_reactVis.ArcSeries, {
        data: this._processData(),
        radiusDomain: [0, 10],
        padAngle: 0.02,
        onValueMouseOver: this._updateHovered,
        onSeriesMouseOut: this._clearHovered,
        onValueClick: onValueClick,
        colorType: "literal",
        style: onValueClick ? {
          "cursor": "pointer"
        } : {}
      }), this._renderCenterText());
    }
  }]);
  return DonutChart;
}(_react.Component);
_defineProperty(DonutChart, "propTypes", {
  data: _propTypes.default.array.isRequired,
  colorMap: _propTypes.default.object,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  margin: _propTypes2.propTypeMargin,
  onValueClick: _propTypes.default.func,
  arcValueFormat: _propTypes.default.func
});
_defineProperty(DonutChart, "defaultProps", {
  width: 400,
  height: 400,
  margin: {
    left: 50,
    right: 50,
    top: 50,
    bottom: 50
  }
});
var _default = (0, _empty.withEmptyView)(DonutChart);
exports.default = _default;